import styles from "./user.module.css";
import { app, db } from "../utils/firebase";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  sendEmailVerification,
  updateProfile,
  sendPasswordResetEmail,
} from "firebase/auth";

import {
  Divider,
  Drawer,
  Button,
  Form,
  Input,
  Avatar,
  Space,
  message,
} from "antd";
import {
  ControlOutlined,
  EditFilled,
  FacebookFilled,
  GoogleCircleFilled,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MailOutlined,
  PlusCircleTwoTone,
  UserOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { setUserProperties } from "firebase/analytics";
import { MyContext } from "../utils/utils";
import { onValue, ref, set } from "firebase/database";
import Modal from "antd/lib/modal/Modal";

const state = {
  email: 0,
  password: 1,
  login: 2,
  create: 3,
};

const User = ({}) => {
  const [visible, setVisible] = useState(false);
  const [loginVisible, setLoginVisible] = useState(state.email);

  const [email, setEmail] = useState(null);
  var password = null;

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    console.log("close");
    setLoginVisible(state.email);
    setEmail(null);
    setVisible(false);
  };

  const googleprovider = new GoogleAuthProvider();

  const auth = getAuth();

  const { currentUser, setCurrentUser } = useContext(MyContext);

  const [loginGoogle, setLoginGoogle] = useState(false);
  const signInPopUp = (provider) => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = provider.credentialFromResult(result);
        const token = credential.accessToken;
        // // The signed-in user info.
        const user = result.user;
        // ...
        setCurrentUser(user);
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  };
  const createAccount = async (values) => {
    const email = values.email;
    const password = values.password;
    const name = values.username;

    try {
      await createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          // ...
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
        });

      await sendEmailVerification(auth.currentUser).catch((err) =>
        console.log(err)
      );

      await updateProfile(auth.currentUser, { displayName: name }).catch(
        (err) => console.log(err)
      );
      setCurrentUser(auth.currentUser);
    } catch (err) {
      console.log(err);
    }
  };

  const updateProfileName = async (value) => {
    const name = value.username;
    await updateProfile(auth.currentUser, { displayName: name }).catch((err) =>
      console.log(err)
    );
    setCurrentUser(auth.currentUser);
    setEditProfile(false);

    onValue(
      ref(db, "users/" + currentUser.uid),
      (snapshot) => {
        const val = snapshot.val();
        for (var key in val) {
          set(
            ref(db, "rooms/" + key + "/joiner/" + currentUser.uid + "/name"),
            name
          );
        }
      },
      {
        onlyOnce: true,
      }
    );
  };
  const onClickNext = (values) => {
    setEmail(values.email);
    signInWithEmailAndPassword(auth, values.email, "'")
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        setCurrentUser(user);
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        if (errorCode == "auth/user-not-found") {
          message.error("존재하지 않는 사용자입니다");
        } else {
          setLoginVisible(state.password);
        }
      });
  };
  const signIn = (values) => {
    var password = values.password;
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        setCurrentUser(user);
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        if (errorCode == "auth/wrong-password") {
          message.error("비밀번호가 올바르지 않습니다");
        }
      });
  };

  const logOut = () => {
    setLoginGoogle(false);
    signOut(auth).then((userCredential) => {
      setCurrentUser(null);
      setLoginVisible(state.email);
    });
  };

  const onClickForgetPassword = () => {
    message.loading({
      content: `${email}으로 비밀번호 재설정 메일을 보내는 중..`,
      key: "updateable",
    });
    sendPasswordResetEmail(auth, email)
      .then(() => {
        // Password reset email sent!

        message.success({
          content: email + "으로 비밀번호 재설정 메일을 보냈습니다.",
          key: "updateable",
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  };

  const buttonStyle = {
    width: "100%",
  };

  const checkEmail = (str) => {
    var reg_email =
      /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    if (!reg_email.test(str)) {
      return false;
    }
    return true;
  };

  const [editProfile, setEditProfile] = useState(false);
  return (
    <>
      <Button
        icon={<UserOutlined />}
        size="large"
        onClick={showDrawer}
        type="circle"
      />

      <Modal
        width={400}
        onCancel={onClose}
        visible={visible}
        footer={null}
        title="로그인"
      >
        <div className={styles.drawer}>
          {currentUser ? (
            <>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Avatar
                  src={currentUser.photoURL}
                  icon={<UserOutlined />}
                  style={{ marginRight: "10px", marginBottom: "10px" }}
                ></Avatar>
                <p>{currentUser.displayName}님 안녕하세요!</p>
              </div>
              <div style={{ display: "block" }}>
                {editProfile ? (
                  <Form
                    name="basic"
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={updateProfileName}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="이름"
                      name="username"
                      rules={[
                        { required: true, message: "이름을 입력해주세요!" },
                      ]}
                    >
                      <Input
                        placeholder="이름"
                        defaultValue={currentUser.displayName}
                      />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
                      <Button
                        icon={<EditFilled />}
                        type="primary"
                        shape="round"
                        htmlType="submit"
                        size="large"
                      >
                        계정 정보 수정
                      </Button>
                      <Button
                        style={{ marginLeft: "10px" }}
                        shape="round"
                        size="large"
                        onClick={() => setEditProfile(false)}
                      >
                        취소
                      </Button>
                    </Form.Item>
                  </Form>
                ) : (
                  <Button
                    type="link"
                    style={{ width: "100%" }}
                    onClick={() => setEditProfile(true)}
                  >
                    계정 관리
                  </Button>
                )}
                <Button icon={<LogoutOutlined />} onClick={logOut}>
                  로그아웃
                </Button>
              </div>
            </>
          ) : (
            <>
              {loginVisible == state.email && (
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={onClickNext}
                    autoComplete="off"
                  >
                    <Form.Item
                      name="email"
                      label="이메일을 입력해주세요"
                      rules={[
                        { required: true, message: "이메일을 입력해주세요!" },
                        () => ({
                          validator(_, value) {
                            if (value == null || checkEmail(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("이메일 형식이 올바르지 않습니다")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input prefix={<MailOutlined />} placeholder="이메일" />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        onClick={() => setLoginVisible(state.create)}
                        style={{ float: "left" }}
                        type="link"
                      >
                        회원 가입
                      </Button>

                      <Button
                        style={{ float: "right" }}
                        type="primary"
                        shape="round"
                        htmlType="submit"
                      >
                        다음
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              )}
              {loginVisible == state.password && (
                <Form
                  name="basic"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  initialValues={{ remember: true }}
                  onFinish={signIn}
                  autoComplete="off"
                >
                  <Form.Item
                    name="password"
                    label="비밀번호를 입력해주세요"
                    rules={[
                      { required: true, message: "비밀번호를 입력해주세요!" },
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="비밀번호"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      style={{ float: "left" }}
                      className="login-form-forgot"
                      type="link"
                      onClick={onClickForgetPassword}
                    >
                      비밀번호를 까먹었어요
                    </Button>

                    <Button
                      style={{ float: "right" }}
                      icon={<LoginOutlined />}
                      type="primary"
                      shape="round"
                      htmlType="submit"
                    >
                      로그인
                    </Button>

                    <Button
                      style={{ float: "right", marginRight: "5px" }}
                      shape="round"
                      onClick={() => {
                        setEmail(null);
                        setLoginVisible(state.email);
                      }}
                    >
                      이전
                    </Button>
                  </Form.Item>
                </Form>
              )}
              {loginVisible == state.create && (
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={createAccount}
                    autoComplete="off"
                  >
                    <Form.Item
                      name="sitepassword"
                      rules={[
                        {
                          required: true,
                          message: "사이트 비밀번호를 입력해주세요!",
                        },
                        () => ({
                          validator(_, value) {
                            if (value == "kaistivf" || value == "") {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("사이트 비밀번호가 틀렸습니다")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input
                        prefix={<LockOutlined />}
                        placeholder="사이트 비밀번호"
                      />
                    </Form.Item>

                    <Form.Item
                      name="username"
                      rules={[
                        { required: true, message: "이름을 입력해주세요!" },
                      ]}
                    >
                      <Input prefix={<UserOutlined />} placeholder="이름" />
                    </Form.Item>

                    <Form.Item
                      name="email"
                      rules={[
                        { required: true, message: "이메일을 입력해주세요!" },
                        () => ({
                          validator(_, value) {
                            if (checkEmail(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("이메일 형식이 올바르지 않습니다")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input prefix={<MailOutlined />} placeholder="이메일" />
                    </Form.Item>

                    <Form.Item
                      name="password"
                      rules={[
                        { required: true, message: "비밀번호를 입력해주세요!" },
                        () => ({
                          validator(_, value) {
                            if (!value || value.length >= 6) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("비밀번호가 최소 6자이여야합니다")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        prefix={<LockOutlined />}
                        placeholder="비밀번호"
                      />
                    </Form.Item>

                    <Form.Item
                      name="confirm"
                      dependencies={["password"]}
                      rules={[
                        { required: true, message: "비밀번호를 확인해주세요!" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("비밀번호가 일치하지 않습니다")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        prefix={<LockOutlined />}
                        placeholder="비밀번호 확인"
                      />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
                      <Button
                        style={buttonStyle}
                        icon={<PlusCircleTwoTone />}
                        type="primary"
                        shape="round"
                        htmlType="submit"
                        size="large"
                      >
                        회원 가입
                      </Button>
                    </Form.Item>
                  </Form>
                  <Button
                    onClick={() => setLoginVisible(state.email)}
                    style={buttonStyle}
                    type="link"
                  >
                    로그인 하기
                  </Button>
                </>
              )}
              <Divider></Divider>

              {loginGoogle ? (
                <>
                  <div>
                    <GoogleCircleFilled style={{ marginRight: "10px" }} />
                    <b> 구글로 로그인하기</b>
                  </div>
                  <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={() => signInPopUp(googleprovider)}
                    autoComplete="off"
                    style={{
                      display: "flex",
                      marginTop: "10px",
                      justifyContent: "space-around",
                    }}
                  >
                    <Form.Item
                      name="sitepassword"
                      rules={[
                        {
                          required: true,
                          message: "사이트 비밀번호를 입력해주세요!",
                        },
                        () => ({
                          validator(_, value) {
                            if (value == "kaistivf" || value == "") {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("사이트 비밀번호가 틀렸습니다")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input
                        prefix={<LockOutlined />}
                        placeholder="사이트 비밀번호"
                        style={{ width: "100%", marginRight: "10px" }}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button htmlType="submit" type="primary" shape="round">
                        확인
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              ) : (
                <Button
                  onClick={() => setLoginGoogle(true)}
                  icon={<GoogleCircleFilled />}
                  type="round"
                >
                  구글로 로그인하기
                </Button>
              )}
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default User;
